// src/components/PortfolioPage.js
import React from "react";

export default function PortfolioPage() {
  return (
    <main className="container py-5">
      <h1 className="mb-3">Portfolio</h1>
      <p className="text-muted">Here are some selected projects. Replace this with your real portfolio.</p>

      <div className="row mt-4">
        <div className="col-md-6 mb-3">
          <div className="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=1200&q=80" className="card-img-top" alt="Project" />
            <div className="card-body">
              <h5 className="card-title">Project One</h5>
              <p className="card-text text-muted">Short description of the project and results.</p>
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-3">
          <div className="card shadow-sm">
            <img src="https://images.unsplash.com/photo-1505685296765-3a2736de412f?auto=format&fit=crop&w=1200&q=80" className="card-img-top" alt="Project" />
            <div className="card-body">
              <h5 className="card-title">Project Two</h5>
              <p className="card-text text-muted">Short description of the project and results.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
